<script>
import { Bar } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes'

export default {
    extends: Bar,
    props: ['data', 'options'],
    computed: {
        chartData: function() {
            return this.data
        },
    },
    methods: {
        renderBarChart: function() {
            this.renderChart(
                {
                    labels: this.data.labels,
                    datasets: [
                        {
                            type: 'line',
                            label: '',
                            data: this.data.data,
                            pointRadius: 0,
                            fill: 'none',
                            borderColor: '#24b0e0a3',
                            barPercentage: 0.6,
                        },
                        {
                            type: 'bar',
                            label: this.data.label,
                            data: this.data.data,
                            backgroundColor: '#24b0e0',
                            barPercentage: 0.6,
                        },
                    ],
                },
                this.options,
            )
        },
    },
    watch: {
        data: function() {
            this.$data._chart.destroy()
            this.renderBarChart()
        },
    },
    mounted() {
        this.renderBarChart()
    },
}
</script>
